<!--经销商组织架构模板详情-->
<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="false"
             :model="dataForm" ref="dataForm" :rules="dataRule">
      <el-row>
        <el-col :span="7">
          <!--模板名称-->
          <el-form-item prop="name"
                        :label="$t('res.departmentTemple.templeName')">
            <el-input  maxlength="80" v-model.trim="dataForm.name"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="7">-->
          <!--&lt;!&ndash;模板英文名称&ndash;&gt;-->
          <!--<el-form-item prop="nameEn"-->
                        <!--:label="$t('res.departmentTemple.templeEnName')">-->
            <!--<el-input maxlength="80" v-model="dataForm.nameEn"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="7">
          <!--经销商规模-->
          <el-form-item prop="dealerScale" :label="$t('res.departmentTemple.scale')">
            <el-select v-model="dataForm.dealerScale"
                       :disabled="typeEdit === 'edit'"
                       >
              <el-option v-for="(item,index) in statusArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align:right;">
        <!--添加部门按钮-->
        <el-button :loading="dataListLoading" v-if="tableDate.length === 0 && isShowDepartmentBut" size="mini" type="primary" @click="addDepartment">{{ $t('res.departmentTemple.addOrg') }}</el-button>
        <!--保存按钮-->
        <el-button :loading="dataListLoading" size="mini" type="primary" @click="saveTemp">{{ $t('res.cri.save') }}</el-button>
      </div>
    </el-form>
    <div class="button-group">
      <!--展开-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="unFoldAll">{{ $t('res.classroom.unFold') }}</el-button>
      <!--收起所有-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="foldAll">{{ $t('res.classroom.fold') }}</el-button>
    </div>
    <el-table
      v-if="isShowTable"
      ref="tableTreeRef"
      :data="tableDate"
      style="width: 100%;margin-bottom: 20px;"
      v-loading="dataListLoading"
      row-key="id"
      border
      :default-expand-all="isExpand"
      :tree-props="{children: 'children'}">
      <!--部门名称-->
      <el-table-column
        prop="departmentName"
        :label="$t('res.department.departmentName')">
      </el-table-column>
      <!--部门代码-->
      <el-table-column
        prop="departmentCode"
        :label="$t('res.department.code')"  align="center">
      </el-table-column>
      <!--排序-->
      <el-table-column
        prop="sort"
        width="200"
        :label="$t('talentpool.sort')"  align="center">
        <template slot-scope="scope">
          <div style="line-height: 34px;">
            <el-input maxlength="10" style="width: 80px!important;display: inline-block;" v-model.trim="scope.row.sort"></el-input>
            <el-button class="el-icon-success ipl" @click="editSort(scope.row)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="200"
        :label="$t('handle')">
        <template slot-scope="scope">
          <!--查看-->
          <span class="el-dropdown-link" @click="viewDepartment(scope.row)">{{ $t('res.vehinfo.check') }}</span>
          <div class="pkg-vertical-divider"></div>
          <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
            <el-dropdown-menu slot="dropdown" style="width: 140px!important;">
              <!--查看详情-->
              <!--<el-dropdown-item @click.native="viewDepartment(scope.row)">{{ $t('res.vehinfo.check') }}-->
              <!--</el-dropdown-item>-->
              <!--新增下级部门-->
              <el-dropdown-item  @click.native="addNextPartment(scope.row)">{{ $t('res.departmentTemple.addNextPost') }}
              </el-dropdown-item>
              <!--修改父级岗位-->
              <el-dropdown-item v-if="scope.row.grade !== 0" @click.native="modifyParentDep(scope.row)">{{$t('talentpool.modifyParentDep')}}
              </el-dropdown-item>
              <!--删除-->
              <el-dropdown-item @click.native="deleteDepartment(scope.row)">{{ $t('res.departmentTemple.delete') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!--选择部门-->
    <el-dialog :title="$t('res.departmentTemple.selectDepartment')"  :visible.sync="isShowDialog" top="15vh" width="50%" :close-on-click-modal="false">
      <el-form :inline="true" :model="positionForm" ref="departmentRef" :rules="positionRule" @submit.native.prevent>
        <el-row>
          <el-col :span="6">
            <el-form-item></el-form-item>
          </el-col>
          <el-col :span="12">
            <!--选择部门-->
            <el-form-item prop="positionId" :label="$t('res.departmentTemple.selectDepartment')">
              <el-select filterable clearable collapse-tags v-model="positionForm.positionId">
                <el-option
                  v-for="item in departmentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-form-item style="text-align: right">
              <!--返回按钮-->
              <el-button :loading="dataListLoading" size="mini" type="primary" @click="backPosition">{{ $t('res.vehinfo.back') }}</el-button>
              <!--保存部门按钮-->
              <el-button :loading="dataListLoading" size="mini" type="primary" @click="saveDepartment">{{ $t('res.cri.save') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!--选择可修改的父岗位-->
    <el-dialog :title="$t('res.departmentTemple.selectDepartment')"  :visible.sync="isShowPartentDialog" top="15vh" width="50%" :close-on-click-modal="false">
      <el-form :inline="true" :model="partentDepForm" ref="partentDepRef" :rules="partentDepRule" @submit.native.prevent>
        <el-row>
          <el-col :span="12" :offset="6">
            <!--选择岗位-->
            <el-form-item prop="depTreeId" :label="$t('res.departmentTemple.selectDepartment')">
              <el-select filterable clearable collapse-tags v-model="partentDepForm.depTreeId">
                <el-option
                  v-for="item in partentPositionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-form-item style="text-align: right">
              <!--返回按钮-->
              <el-button size="mini" :loading="dataListLoading" type="primary" @click="backPartentPosition">{{$t('res.vehinfo.back')}}</el-button>
              <!--保存按钮-->
              <el-button size="mini" :loading="dataListLoading" type="primary" @click="savePartentPosition">{{$t('res.cri.save')}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </el-card>
</template>

<script>
export default {
  data () {
    return {
      fileList: [],
      isExpand: false,
      statusArr: this.enums['DealerSize'], // 经销商规模
      // 已选择的部门数组
      departmentIdArray: [],
      isShowDialog: false,
      dataListLoading: false,
      typeEdit: '',
      dataForm: {
        id: '',
        name: '',
        nameEn: '',
        dealerScale: ''
      },
      tableDate: [],
      positionForm: {
        positionId: ''
      },
      departmentList: [],
      selectPosition: undefined,
      positionRule: {
        positionId: [
          { required: true, message: this.$t('res.departmentTemple.department') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
      },
      dataRule: {
        name: [
          { required: true, message: this.$t('res.departmentTemple.templeName') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        // nameEn: [
        //   { required: true, message: this.$t('res.departmentTemple.templeEnName') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        dealerScale: [
          { required: true, message: this.$t('res.departmentTemple.scale') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
      },
      // 新增或编辑
      type: undefined,
      // 是否是根节点
      isRoot: false,
      // 是否显示添加根部门按钮
      isShowDepartmentBut: false,
      isShowTable: true,
      ///////////////////////修改父级岗位/////////////////////////////////////////////////
      // 可修改的父岗位
      isShowPartentDialog: false,
      partentDepForm: {
        depTreeId: ''
      },
      partentDepRule: {
        // 岗位不能为空
        depTreeId: [
          { required: true, message: this.$t('res.departmentTemple.department') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
      },
      // 可选择的父节点
      partentPositionList: [],
      // 修改父节点选中的数据
      selectDepPosition: undefined
    }
  },
  // 进来页面初始化获取数据
  mounted () {
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.ORGTEMP_MANAGER, (data) => {
      this.initMethod()
    })
  },
  watch: {
    tableDate: function () {
      this.$nextTick(() => {
        this.expandAll()
      })
    }
  },
  methods: {
    // 初始化方法
    initMethod () {
      // 清空id
      this.dataForm.id = ''
      // 清空操作类型
      this.typeEdit = ''
      // 清空table
      this.tableDate = []
      this.isShowDepartmentBut = false
      this.$nextTick(() => {
        this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      })
      this.type = this.$route.query.type
      if (this.$route.query.id !== undefined) {
        this.dataForm.id = this.$route.query.id
        this.typeEdit = this.$route.query.type
        if (this.type === 'edit') {
          this.getInfo()
        }
      }
    },
    // 调用接口获取信息，渲染页面
    getInfo () {
      this.dataListLoading = true
      let _this = this
      _this.$request.get(`/talent/template/info/${_this.dataForm.id}`).then((data) => {
        _this.dataForm.name = data.name
        _this.dataForm.nameEn = data.nameEn
        _this.dataForm.dealerScale = data.dealerScale
        _this.dataForm.id = data.id
        _this.departmentIdArray = data.ids
        _this.tableDate = data.departmentTreeList
        // 如果table中无数据，则显示选择根岗位按钮
        if (_this.tableDate.length === 0) {
          _this.isShowDepartmentBut = true
        }
        _this.dataListLoading = false
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 查询部门信息
    queryDeparment () {
      this.dataListLoading = true
      this.$request.get(`/talent/department/queryDepartment`).then((data) => {
        let _this = this
        _this.departmentList = []
        let map = new Map()
        _this.departmentIdArray.forEach(function (item) {
          map.set(item, item)
        })
        data.forEach(function (item) {
          if (!map.has(item.id)) {
            let param = { value: item.id, label: item.name }
            _this.departmentList.push(param)
          }
        })
        _this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 取消按钮
    backPosition () {
      this.isShowDialog = false
    },
    // 保存岗位
    saveDepartment () {
      this.$refs['departmentRef'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          // 保存下级岗位
          let param = ''
          if (this.isRoot) {
            // 新增根节点
            param = {
              'templateId': this.dataForm.id,
              'departmentId': this.positionForm.positionId,
              'grade': 0
            }
          } else {
            // 新增子节点
            param = {
              'templateId': this.selectPosition.templateId,
              'departmentId': this.positionForm.positionId,
              'parentId': this.selectPosition.id,
              'grade': this.selectPosition.grade + 1
            }
          }
          this.$request.post(
            `/talent/departmenttree/save`, param
          ).then((data) => {
            // 关闭弹框
            this.isShowDialog = false
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.dataListLoading = false
                this.getInfo()
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    },
    // 新增下级岗位
    addNextPartment (row) {
      // 查询部门信息
      this.queryDeparment()
      // 清除下拉选
      this.positionForm.positionId = ''
      // 清空表单的校验
      this.$nextTick(() => {
        this.$refs['departmentRef'].resetFields()
      })
      this.isShowDialog = true
      this.isRoot = false
      this.selectPosition = row
    },
    // 查看详情
    viewDepartment (row) {
      let query = {}
      query.type = 'edit'
      let name = 'ochart-ochartdepartment-view'
      query.id = row.departmentId
      query.parentDepartmentName = row.parentDepartmentName
      this.$router.push({
        name: name,
        query: query
      })
    },
    // 删除部门树上的部门
    deleteDepartment (row) {
      let message = ''
      if (row.children.length > 0) {
        message = this.$t('res.department.deleteDepartment')
      } else {
        message = this.$t('res.department.deleteDep')
      }
      this.$confirm(message, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let param = {
          'id': row.id,
          'templateId': row.templateId,
          'version': ''
        }
        this.dataListLoading = true
        this.$request.post(
          `/talent/departmenttree/delete`, param
        ).then((res) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getInfo()
              this.dataListLoading = false
            }
          })
        }).catch(() => {
          this.dataListLoading = false
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存模板
    saveTemp () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          let url = ''
          if (this.type === 'add') {
            url = '/talent/template/save'
          } else if (this.type === 'edit') {
            url = '/talent/template/update'
          }
          this.$request.post(
            url, this.dataForm
          ).then((data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                if (this.type === 'edit') {
                  this.getInfo()
                }
                if (this.type === 'add') {
                  this.dataForm.id = data.id
                  this.type = 'edit'
                  this.getInfo()
                }
                this.isShowDepartmentBut = true
                this.dataListLoading = false
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    },
    // 添加根岗位
    addDepartment () {
      // 查询部门信息
      this.queryDeparment()
      // 清除下拉选
      this.positionForm.positionId = ''
      // 清空表单的校验
      this.$nextTick(() => {
        this.$refs['departmentRef'].resetFields()
      })
      this.isShowDialog = true
      this.isRoot = true
    },
    getRowKeys (row) {
      return row.id
    },
    /**
     * 触发所有展开图标的click事件
     */
    expandAll () {
      // 获取点击的箭头元素
      let els = document.getElementsByClassName('el-table__expand-icon')
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    },
    /**
     * 展开所有下级
     */
    unFoldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
        let _this = this
        window.setTimeout(function () {
          _this.expandAll()
        }, 300)
      })
    },
    /**
     * 收起所有下级
     */
    foldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
      })
    },
    /**
     * 修改排序字段
     */
    editSort (row) {
      // 如果建议值为空提示
      if (!row.sort && row.sort !== 0) {
        this.$message.warning(this.$t('talentpool.sortIsNotEmpty'))
        return false
      }
      if (!this.isPositiveInteger(row.sort)) {
        this.$message.warning(this.$t('talentpool.sortMustNumber'))
        return false
      }
      this.$request.post(`/talent/template/modifyDepSort`, row).then((data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            // this.getInfo()
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 校验是否是正整数
    isPositiveInteger (s) {
      let re = /^\+?[1-9][0-9]*$/
      return re.test(s)
    },
    ////////////////////////修改父级部门/////////////////////////////////////////////////
    // 修改父级节点
    modifyParentDep (row) {
      // 查询可选择的父级节点
      this.queryParentDep(row)
      // 清楚下拉选
      this.partentDepForm.depTreeId = ''
      this.isShowPartentDialog = true
      this.selectDepPosition = row
      this.$nextTick(() => {
        this.$refs.partentDepRef.clearValidate()
      })
    },
    // 查询选择的父级节点
    queryParentDep (row) {
      this.partentPositionList = []
      this.dataListLoading = true
      this.$request.post(`/talent/departmenttree/queryParentDep`, row).then((data) => {
        let _this = this
        data.forEach(function (item) {
          let param = { value: item.id, label: item.name }
          _this.partentPositionList.push(param)
        })
        _this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 返回修改父级节点
    backPartentPosition () {
      this.isShowPartentDialog = false
    },
    savePartentPosition () {
      this.$refs['partentDepRef'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          this.selectDepPosition.parentId = this.partentDepForm.depTreeId
          this.$request.post(
            `/talent/departmenttree/savePartentDep`, this.selectDepPosition
          ).then((data) => {
            // 关闭弹框
            this.isShowPartentDialog = false
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.getInfo()
                this.dataListLoading = false
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    }
  }
}
</script>
<style>
  /*.cell .el-table__placeholder {*/
    /*position: relative;*/
    /*margin-left: 20px;*/
  /*}*/
  .input-align-right input {
    text-align: right;
  }
  .button-group {
    margin-bottom: 10px;
  }
  /* 竖线样式 */
  .pkg-vertical-divider {
    display: inline-block;
    width: 1px;
    height: 4em;margin: 0 8px;
    vertical-align: middle;
    position: relative;
    background-color: #dcdfe6;
  }
</style>
